import { createContext, useContext } from "react";

type AppTrackerContextType = {
	getMillisecondsSinceStart: () => number | null;
	checkoutLoaded: () => void;
	getMillisecondsSinceCheckoutLoaded: () => number | null;
};

export const AppTrackerContext = createContext<AppTrackerContextType | undefined>(undefined);

export const useAppTracker = () => {
	const context = useContext(AppTrackerContext);
	if (context === undefined) {
		throw new Error("useAppTracker must be used within an AppTrackerProvider");
	}
	return context;
};
